import { useMemo } from 'react';

import {
  AddSpecifiedItemModalProps,
  AddSpecifiedItemsModal,
  BoostCalendarModal,
  BoostCalendarModalProps,
  EditTravellers,
  EditTravellersProps,
  EmailQuote,
  EmailQuoteFailed,
  EmailQuoteSuccess,
  ExcessModal,
  MoreInfoModalBody,
  MoreInfoModalBodyProps,
  PersonalisationBoostModal,
  ProcessingPaymentModal,
  ProcessingPaymentModalProps,
  ReferralModal,
  ReferralModalProps,
  SelectDestinations,
  SelectDestinationsProps,
  SelectTravelDates,
  SelectTravelDatesProps,
  UsTravelDatesProtectionModal,
} from '@components';
import {
  PolicyDetails,
  PolicyDetailsProps,
} from '@components/policyDetails/policyDetails.component';

const modalBodyComponents = {
  SelectTravelDates,
  MoreInfoModalBody,
  SelectDestinations,
  AddSpecifiedItemsModal,
  BoostCalendarModal,
  ProcessingPaymentModal,
  ReferralModal,
  UsTravelDatesProtectionModal,
  EditTravellers,
  EmailQuote,
  EmailQuoteSuccess,
  EmailQuoteFailed,
  ExcessModal,
  PersonalisationBoostModal,
  PolicyDetails,
};

export type ComponentProps = {
  SelectTravelDates: SelectTravelDatesProps;
  MoreInfoModalBody: MoreInfoModalBodyProps;
  SelectDestinations: SelectDestinationsProps;
  AddSpecifiedItemsModal: AddSpecifiedItemModalProps;
  BoostCalendarModal: BoostCalendarModalProps;
  ProcessingPaymentModal: ProcessingPaymentModalProps;
  ReferralModal: ReferralModalProps;
  UsTravelDatesProtectionModal: Record<string, unknown>;
  EditTravellers: EditTravellersProps;
  ScanToDownload: Record<string, unknown>;
  EmailQuote: Record<string, unknown>;
  EmailQuoteSuccess: Record<string, unknown>;
  EmailQuoteFailed: Record<string, unknown>;
  ExcessModal: Record<string, unknown>;
  PolicyDetails: PolicyDetailsProps;
  PersonalisationBoostModal: Record<string, unknown>;
};

export type ModalComponentName = keyof typeof modalBodyComponents;

export type ModalBodyProps<T extends ModalComponentName> = {
  type: T;
} & ComponentProps[T];

export function ModalBody<T extends ModalComponentName>(props: ModalBodyProps<T>) {
  const BodyComponent = useMemo(
    () => (modalBodyComponents?.[props?.type] as React.FC<ComponentProps[T]>) ?? null,
    [props?.type],
  );

  if (!BodyComponent) {
    return null;
  }

  return <BodyComponent {...(props as ComponentProps[T])} />;
}
